import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./layouts/AppShell";
import { AccountPage } from "./pages/AccountPage";
import { ApiKeysPage } from "./pages/ApiKeysPage";
import { ContactsPage } from "./pages/ContactsPage";
import { DashboardPage } from "./pages/DashboardPage";
import { DevicesPage } from "./pages/DevicesPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { InvitePage } from "./pages/InvitePage";
import { LoginPage } from "./pages/LoginPage";
import { MessagingPage } from "./pages/MessagingPage";
import { TemplatesPage } from "./pages/TemplatesPage";
import { WebhooksPage } from "./pages/WebhooksPage";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { PublicRoute } from "./routes/PublicRoute";
import { useAuthStore } from "./stores/auth-store";
import { useThemeStore } from "./stores/theme-store";

export function App() {
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const initTheme = useThemeStore((s) => s.init);

  // Runs once before any route renders: turns a persisted token back into a live session so a
  // hard refresh on /dashboard doesn't bounce the user to /login.
  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        </Route>

        {/* Invite redemption — public but outside PublicRoute so logged-in users can still reach it */}
        <Route path="/invite/:token" element={<InvitePage />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<AppShell />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/devices" element={<DevicesPage />} />
            <Route path="/messaging" element={<MessagingPage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/webhooks" element={<WebhooksPage />} />
            <Route path="/api-keys" element={<ApiKeysPage />} />
            <Route path="/account" element={<AccountPage />} />
          </Route>
        </Route>

        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
